import React from "react";
import Head from "next/head";
import useBgByClass from "@/hooks/useBgByClass";

interface IOpenGraph {
  type?: string;
  url?: string;
  image?: string;
  title?: string;
  description?: string;
  updatedTime?: string;
  siteName?: string;
  author?: string;
  tag?: string;
}

interface IHelmetProps {
  children?: React.ReactNode;
  title?: string;
  bodyClassName?: string;
  htmlClassName?: string;
  keywords?: string;
  description?: string;
  openGraph?: IOpenGraph;
}

export const Helmet = ({
  children,
  title = "",
  bodyClassName = "",
  htmlClassName = "",
  keywords,
  description = "",
  openGraph,
}: IHelmetProps) => {
  /* 响应 body/html 上的 className 变更 */
  useBgByClass(bodyClassName);
  useBgByClass(
    htmlClassName,
    typeof document === "undefined"
      ? undefined
      : document.getElementsByTagName("html")[0]
  );
  return (
    <Head>
      <title>{title || "Chereads: Fictional Stories Hub"}</title>
      {/* for _document.js 直出className */}
      {bodyClassName && <body className={`vw100 ${bodyClassName}`} />}
      {htmlClassName && <html className={htmlClassName} />}
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}

      {openGraph?.title && (
        <meta property="og:title" content={openGraph.title} />
      )}
      {openGraph?.description && (
        <meta property="og:description" content={openGraph.description} />
      )}
      {openGraph?.type && <meta property="og:type" content={openGraph.type} />}
      {openGraph?.url && <meta property="og:url" content={openGraph.url} />}
      {openGraph?.image && (
        <meta property="og:image" content={openGraph.image} />
      )}
      {openGraph?.tag && <meta property="og:tag" content={openGraph.tag} />}
      {openGraph?.updatedTime && (
        <meta property="og:updated_time" content={openGraph.updatedTime} />
      )}
      {openGraph?.siteName && (
        <meta property="og:site_name" content={openGraph.siteName} />
      )}
      {openGraph?.author && (
        <meta property="og:author" content={openGraph.author} />
      )}
      {children}
    </Head>
  );
};

export default Helmet;
